import type { TFunction } from 'i18next';

const MODALITY_KEYS = [
  'spoken',
  'introduction',
  'code-read-only',
  'code-write',
  'technical',
  'behavioral',
  'general',
] as const;

type InterviewModalityKey = typeof MODALITY_KEYS[number];

function isModalityKey(value: string): value is InterviewModalityKey {
  return (MODALITY_KEYS as readonly string[]).includes(value);
}

/** Localized label for interview question modality (spoken, code review, etc.). */
export function getInterviewModalityLabel(
  questionType: string | null | undefined,
  t: TFunction<'interview'>,
): string {
  const normalized = (questionType || 'general').toLowerCase();
  const key = isModalityKey(normalized) ? normalized : 'general';
  return t(`live.questions.modality.${key}`);
}
